import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";
import { motion } from "framer-motion";
import Tilt from "react-parallax-tilt";
import { playHoverSound, playClickSound } from "../../utils/sound";

const ProjectCard = (props) => {
  return (
    <Tilt
      perspective={1000}
      glareEnable={true}
      glareMaxOpacity={0.12}
      glareColor="rgba(255, 255, 255, 0.3)"
      glarePosition="all"
      glareBorderRadius="20px"
      tiltMaxAngleX={8}
      tiltMaxAngleY={8}
      style={{ height: "100%" }}
    >
      <motion.div
        whileHover={{ y: -4 }}
        transition={{ type: "spring", stiffness: 300, damping: 20 }}
        style={{ height: "100%" }}
        onMouseEnter={playHoverSound}
      >
        <Card className="project-card-view">
          {props.imgPath && (
            <div style={{ overflow: "hidden", position: "relative" }}>
              <Card.Img 
                variant="top" 
                src={props.imgPath} 
                alt="card-img" 
                style={{
                  transition: "transform 0.5s ease",
                }}
                className="project-card-img"
              />
            </div>
          )}
          <Card.Body style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <Card.Title>{props.title}</Card.Title>
            <Card.Text style={{ textAlign: "justify", flexGrow: 1 }}>
              {props.description}
            </Card.Text>
            <div style={{ marginTop: "auto", display: "flex", gap: "10px" }}>
              <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                <Button 
                  variant="primary" 
                  href={props.ghLink} 
                  target="_blank"
                  onClick={playClickSound}
                >
                  <BsGithub /> &nbsp;
                  {props.isBlog ? "Blog" : "GitHub"}
                </Button>
              </motion.div>

              {!props.isBlog && props.demoLink && (
                <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                  <Button
                    variant="primary"
                    href={props.demoLink}
                    target="_blank"
                    onClick={playClickSound}
                  >
                    <CgWebsite /> &nbsp;
                    {"Demo"}
                  </Button>
                </motion.div>
              )}
            </div>
          </Card.Body>
        </Card>
      </motion.div>
    </Tilt>
  );
}
export default ProjectCard;
